export function copyToClipboard(
  text: string,
  {
    onSuccess = () => {},
    onError = () => {},
  }: { onSuccess?: () => void; onError?: (error: Error) => void } = {},
) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then(onSuccess, onError);
  } else {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        onSuccess();
      } else {
        onError(new Error('Could not copy text'));
      }
    } catch (err) {
      onError(err as Error);
    }

    document.body.removeChild(textArea);
  }
}
